var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", [_vm._v("Filters:")]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("datepicker", {
            attrs: {
              "calendar-button": true,
              "calendar-button-icon": "fa fa-calendar",
              "clear-button": true,
              "clear-button-icon": "fa fa-times",
              "bootstrap-styling": true,
              format: "yyyy MMM dd",
              typeable: _vm.isTypeable
            },
            on: { input: _vm.changed },
            model: {
              value: _vm.options.startDate,
              callback: function($$v) {
                _vm.$set(_vm.options, "startDate", $$v)
              },
              expression: "options.startDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 text-center date-to" }, [
        _vm._v("\n            to\n        ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("datepicker", {
            attrs: {
              "calendar-button": true,
              "calendar-button-icon": "fa fa-calendar",
              "clear-button": true,
              "clear-button-icon": "fa fa-times",
              "bootstrap-styling": true,
              format: "yyyy MMM dd",
              typeable: _vm.isTypeable
            },
            on: { input: _vm.changed },
            model: {
              value: _vm.options.endDate,
              callback: function($$v) {
                _vm.$set(_vm.options, "endDate", $$v)
              },
              expression: "options.endDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "row reverese-clerical-toggles" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options.showReversed,
                    expression: "options.showReversed"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.options.showReversed)
                    ? _vm._i(_vm.options.showReversed, null) > -1
                    : _vm.options.showReversed
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.options.showReversed,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "showReversed",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "showReversed",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "showReversed", $$c)
                      }
                    },
                    _vm.changed
                  ]
                }
              }),
              _vm._v(
                "\n                        Show reversed\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options.showClerical,
                    expression: "options.showClerical"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.options.showClerical)
                    ? _vm._i(_vm.options.showClerical, null) > -1
                    : _vm.options.showClerical
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.options.showClerical,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "showClerical",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "showClerical",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "showClerical", $$c)
                      }
                    },
                    _vm.changed
                  ]
                }
              }),
              _vm._v(
                "\n                        Show clerical\n                    "
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("h5", [_vm._v("Sorting:")]),
    _vm._v(" "),
    _c("div", { staticClass: "row filter-functions-sort-mobile" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "input-group no-borders" }, [
          _c("label", { staticClass: "input-group-addon" }, [
            _vm._v("Results at a time:")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.options.pageSize,
                  expression: "options.pageSize"
                }
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.options,
                      "pageSize",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.changed
                ]
              }
            },
            [
              _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "25" } }, [_vm._v("25")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "10000" } }, [_vm._v("All")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 sort-by" }, [
        _c("div", { staticClass: "input-group no-borders" }, [
          _c("label", { staticClass: "input-group-addon" }, [
            _vm._v("Sort by:")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.options.sortDirection,
                  expression: "options.sortDirection"
                }
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.options,
                      "sortDirection",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.changed
                ]
              }
            },
            [
              _c("option", { attrs: { value: "DESC" } }, [
                _vm._v("Recent first")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "ASC" } }, [
                _vm._v("Oldest first")
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 expand-notes" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.options.expandNotes,
                expression: "options.expandNotes"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.options.expandNotes)
                ? _vm._i(_vm.options.expandNotes, null) > -1
                : _vm.options.expandNotes
            },
            on: {
              change: function($event) {
                var $$a = _vm.options.expandNotes,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.options, "expandNotes", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.options,
                        "expandNotes",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.options, "expandNotes", $$c)
                }
              }
            }
          }),
          _vm._v("\n                Expand all notes\n            ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc473140", { render: render, staticRenderFns: staticRenderFns })
  }
}